"use strict"

import BaseCustomLayer from "./BaseCustomLayer";
import {getRandomColors} from "../common/CommonFun"

export default class PieCustomLayer extends BaseCustomLayer {
  constructor(id, data, options = {}) {
    super(id, PieCustomLayer.name, data, options);
  }

  /**
   * 将数据转化为饼图
   * @param item
   * { point:[112.6,45],values:[35.6,41.2,155.9],}
   * @param colors
   * ["","",]
   */
  createChart(item, colors) {
    let sum = this.sum(item.values);



    //计算占比
    let radio;
    if (sum > 0) {
      radio = item.values.map((val) => {
        return val / sum;
      })
    } else {
      radio = item.values.map(() => {
        return 0;
      })
    }

    let cvs = document.createElement('canvas');

    cvs.width = this.params.width;//设置canvas宽
    cvs.height = this.params.width;//设置canvas高
    cvs.borderRadius = '50%'
    //获取上下文
    let ctx = cvs.getContext("2d");
    //画图
    let x0 = Math.floor(this.params.width/2), y0 = x0;//圆心
    let radius = (this.params.width-2)/2;
    let tempAngle = -90;//画圆的起始角度
    for (let i = 0; i < radio.length; i++) {
      let startAngle = tempAngle * Math.PI / 180;//起始弧度
      let angle = radio[i] * 360;
      let endAngle = (tempAngle + angle) * Math.PI / 180;//结束弧度
      ctx.beginPath();
      ctx.moveTo(x0, y0);
      ctx.fillStyle = colors[i];
      ctx.arc(x0, y0, radius, startAngle, endAngle);
      ctx.fill();
      tempAngle += angle;
    }

    let image = new Image();
    image.src = cvs.toDataURL("image/png");
    image.style.cursor="pointer"
    return image;
  }

}



// WEBPACK FOOTER //
// ./src/layer/PieCustomLayer.js